import { Component, OnInit, Optional, Inject } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DentalService } from 'src/app/_service/dental.service';
declare var $: any;

@Component({
  selector: 'app-accounts-remarks',
  templateUrl: './accounts-remarks.component.html',
  styleUrls: ['./accounts-remarks.component.css']
})
export class AccountsRemarksComponent implements OnInit {

  accountsForm: FormGroup; submitted = false; loading: boolean = false; scanId: any = ''; leadId: any = ''; myrole: string; data_loading: boolean = false; err_msg = ''; other_role_field_disabled: boolean = true;
  
  constructor(public dialogRef: MatDialogRef<AccountsRemarksComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute,private dentalapi: DentalService) { 
      dialogRef.disableClose = true;
      this.scanId = data.scanId;
      this.leadId = data.leadId;
      this.accountsForm = this.formBuilder.group({
        'receivedAmtResources': this.formBuilder.array([]) ,
      });
    }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.fetchReceivedAmountData();
    if(this.myrole == '1' || this.myrole == '9')
    {
      this.other_role_field_disabled = false;
    }
  }

  receivedAmtResources() : FormArray {
    return this.accountsForm.get("receivedAmtResources") as FormArray
  }

 
  async save_payment_remarks() {
    this.submitted = true;
    this.loading = true;

    if (this.accountsForm.invalid) {
      this.loading = false;
      return;
    }
    this.accountsForm.value.scanId = parseInt(this.scanId);
    this.accountsForm.value.leadId = parseInt(this.leadId);
    await this.dentalapi.addAccountsRemarkData(this.accountsForm.value)
      .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.sharedapi.presentToast(data.msg);
        }
        else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
  }

  

  async fetchReceivedAmountData()
  {
      this.data_loading = true;
      this.dentalapi.fetchReceivedAmountForAccounts(this.leadId, this.scanId).subscribe((data:any) => {
        if(data.status)
        {
          this.data_loading = false;
          let controlArray = this.accountsForm.get('receivedAmtResources') as FormArray;
          controlArray.clear();
          data.data.forEach((element, index) => {
              controlArray.push(this.formBuilder.group({
                payment_mode: element.payment_mode,
                payment_screenshot_link: element.payment_screenshot_link,
                received_amt: element.received_amt,
                verified_by_accounts: element.verified_by_accounts,
                accounts_remarks: element.accounts_remarks,
                payment_rec_date_by_acc: element.payment_rec_date_by_acc,
                rec_amount_by_account: element.rec_amount_by_account,
                scanPaymentId :element.id
              }));
          });
          console.log(this.accountsForm.value.receivedAmtResources[3].payment_screenshot_link);
        } else {
          this.data_loading = false;
          this.err_msg = data.msg;
        }
      });
      
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

}
